export default
[
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Honda.png",
        title:"Honda"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Hyundai.png",
        title:"Hyundai"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Kia.png",
        title:"Kia"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Mazda.png",
        title:"Mazda"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Toyota.png",
        title:"Toyota"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Mitsubishi.png",
        title:"Mitsubishi"
    },
    {
        src:"https://mhesham32cdn.netlify.com/img/elmohandess/logos/Nissan.png",
        title:"Nissan"
    }
];


// WEBPACK FOOTER //
// ./src/data/logosData.js